module.exports = __webpack_public_path__ + "media/images/talent/mv-03-aa9f108f38267a529e1a0fabd2875ec9.png";